export class GroupedType {
  public value: string;
  public displayName: string;

  constructor(value: string, displayName: string) {
    this.value = value;
    this.displayName = displayName;
  }
}
